import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FeedbackComponent } from './feedback.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { SmBtnModule } from 'common/components/ui-components/sm-btn/sm-btn.module';
import { SmFormModule } from 'common/components/ui-components/sm-form/sm-form.module';
import { SmInputModule } from 'common/components/ui-components/sm-input/sm-input.module';
import { SmSimpleTextareaComponent } from 'common/components/ui-components/sm-simple-textarea/sm-simple-textarea.component';
import { SmSimpleTextareaModule } from 'common/components/ui-components/sm-simple-textarea/sm-simple-textarea.module';
import { SmSelectModule } from 'common/components/ui-components/sm-select/sm-select.module';
import { SmSubFormModule } from 'common/components/ui-components/sm-sub-form/sm-sub-form.module';
import { SmUiToolbarModule } from 'common/components/ui-components/sm-ui-toolbar/sm-ui-toolbar.module';

const routes: Routes = [
  {
      path: '',
      component: FeedbackComponent
  }
];


@NgModule({
  declarations: [FeedbackComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    SmInputModule,
    FormsModule,
    SmFormModule,
    ReactiveFormsModule,
    SmBtnModule,
    SmSimpleTextareaModule,
    SmSelectModule,
    SmSubFormModule,
    SmUiToolbarModule
  ],
  exports:[FeedbackComponent]
})
export class FeedbackModule { }
